import merge, { isMergeObj } from "./merge";
const clone = (obj, mergeFn = merge) => isMergeObj(obj) ? mergeFn(Array.isArray(obj) ? [] : {}, obj) : obj;
export default clone;